import AuthService from "./AuthService";
import EmployeeApi from "../moduleApi/EmployeeApi";
import EmployeeRoleApi from "../moduleApi/EmployeeRoleApi";
import ProfileApi from "../moduleApi/ProfileApi";
import CompanyApi from "../moduleApi/CompanyApi";
import RoleApi from "../moduleApi/RoleApi";
import { store } from "../store/store";

let bootstrapPromise = null;
let bootstrapContextHasWarnings = false;

function resetStoreAuthContext() {
  store.commit("getListEmployeeRoleIds", undefined);
  store.commit("getListEmployeeRoles", undefined);
  store.commit("getCurrentEmployeeRoleCode", undefined);
  store.commit("getListFeature", undefined);
  store.commit("getCurrentUser", undefined);
  store.commit("getCompanyInfo", undefined);
  store.commit("getUserProfile", undefined);
  store.commit("getEmployeeInfo", undefined);
}

function hasLoadedContext() {
  return !!(store.state.currentUser && store.state.listFeature);
}

function setRoleFeatures(employeeFeatures, roleId, listFeature) {
  var featureByRole = employeeFeatures.filter((item) => item.role_id == roleId);
  featureByRole.forEach((item) => {
    listFeature.push(item.feature_code);
  });
}

async function loadUserAccessContext(currentUser) {
  bootstrapContextHasWarnings = false;
  var listFeature = ["*"];
  var employeeRes;
  var profileApiRes;
  var currentCompanyRes;

  try {
    var optionalContext = await Promise.allSettled([
      ProfileApi.findById(currentUser.id, true),
      CompanyApi.findById(currentUser.id, true),
      EmployeeApi.findById(currentUser.id, true),
    ]);

    profileApiRes =
      optionalContext[0].status === "fulfilled" ? optionalContext[0].value : null;
    currentCompanyRes =
      optionalContext[1].status === "fulfilled" ? optionalContext[1].value : null;
    employeeRes =
      optionalContext[2].status === "fulfilled" ? optionalContext[2].value : null;
  } catch (error) {
    bootstrapContextHasWarnings = true;
    console.warn("Cannot load optional auth bootstrap context", error);
  }

  if (profileApiRes && profileApiRes.result) {
    store.commit("getUserProfile", profileApiRes.result);
  }

  if (currentCompanyRes && currentCompanyRes.result) {
    store.commit("getCompanyInfo", currentCompanyRes.result);
  } else if (profileApiRes && profileApiRes.result && profileApiRes.result.company_id) {
    try {
      var profileCompanyRes = await CompanyApi.findById(
        profileApiRes.result.company_id,
        true
      );
      if (profileCompanyRes.result) {
        store.commit("getCompanyInfo", profileCompanyRes.result);
      }
    } catch (error) {
      console.warn("Cannot load company profile context", error);
    }
  }

  if (employeeRes && employeeRes.result) {
    store.commit("getEmployeeInfo", employeeRes.result);
  }

  if (employeeRes && employeeRes.result) {
    try {
      var employeeRoleContext = await Promise.allSettled([
        EmployeeRoleApi.getAllFeaturesOfEmployee(),
        EmployeeRoleApi.list(
          {
            filters: "employee_id=" + employeeRes.result.id,
          },
          true
        ),
      ]);

      var allFeatureByEmployeeId =
        employeeRoleContext[0].status === "fulfilled"
          ? employeeRoleContext[0].value
          : null;
      var employeeRoleApiRes =
        employeeRoleContext[1].status === "fulfilled"
          ? employeeRoleContext[1].value
          : null;

      if (
        employeeRoleContext.some((item) => item.status !== "fulfilled")
      ) {
        bootstrapContextHasWarnings = true;
      }

      if (
        employeeRoleApiRes &&
        employeeRoleApiRes.result &&
        employeeRoleApiRes.result.length > 0
      ) {
        store.commit(
          "getListEmployeeRoleIds",
          employeeRoleApiRes.result[0].role_ids
        );

        if (employeeRoleApiRes.result[0].role_ids.length > 0) {
          try {
            var listRole = await RoleApi.list({
              filters: "id:in:" + employeeRoleApiRes.result[0].role_ids.join(","),
              limit: employeeRoleApiRes.result[0].role_ids.length,
              fields: "id,code,name",
            });

            var currentRoleIdAtLocalStorage = localStorage.getItem("currentRoleId");
            var currentRoleId = employeeRoleApiRes.result[0].role_ids[0];
            var selectedRole = null;
            var roleCodes = [];

            if (
              currentRoleIdAtLocalStorage &&
              employeeRoleApiRes.result[0].role_ids.includes(currentRoleIdAtLocalStorage)
            ) {
              currentRoleId = currentRoleIdAtLocalStorage;
            } else {
              localStorage.setItem("currentRoleId", currentRoleId);
            }

            selectedRole = listRole.result.find((role) => role.id == currentRoleId);
            if (selectedRole && selectedRole.name) {
              localStorage.setItem("currentRoleName", selectedRole.name);
            }
            listRole.result.forEach((role) => {
              roleCodes.push(role.code);
            });
            store.commit("getListEmployeeRoles", roleCodes);

            var currentRole = listRole.result.find((role) => role.id == currentRoleId);
            store.commit(
              "getCurrentEmployeeRoleCode",
              currentRole ? currentRole.code : roleCodes[0] || null
            );
          } catch (error) {
            bootstrapContextHasWarnings = true;
            console.warn("Cannot load role codes during auth bootstrap", error);
          }
        }
      }

      if (
        employeeRoleApiRes &&
        employeeRoleApiRes.result &&
        employeeRoleApiRes.result.length > 0 &&
        allFeatureByEmployeeId &&
        allFeatureByEmployeeId.result &&
        allFeatureByEmployeeId.result.length > 0
      ) {
        var currentRoleIdAtLocalStorage = localStorage.getItem("currentRoleId");
        var currentRoleId = employeeRoleApiRes.result[0].role_ids[0];

        if (!currentRoleIdAtLocalStorage) {
          localStorage.setItem("currentRoleId", currentRoleId);
        } else {
          currentRoleId = currentRoleIdAtLocalStorage;
        }

        setRoleFeatures(allFeatureByEmployeeId.result, currentRoleId, listFeature);
      }

      if (employeeRes && employeeRes.result) {
        ["FT2200", "FT2201"].forEach((featureCode) => {
          if (!listFeature.includes(featureCode)) {
            listFeature.push(featureCode);
          }
        });
      }
    } catch (error) {
      bootstrapContextHasWarnings = true;
      console.warn("Cannot load employee access context", error);
    }
  } else {
    try {
      var allFeature = await EmployeeRoleApi.getAllFeaturesOfCustomerOrAdmin({
        roleName: currentUser.roles.includes("AdminSystem")
          ? "AdminSystem"
          : "Customer",
      });

      if (allFeature.result) {
        var uniqueFeatures = [
          ...new Map(allFeature.result.map((item) => [item.feature_code, item])).values(),
        ];
        uniqueFeatures.forEach((item) => {
          listFeature.push(item.feature_code);
        });
      }
    } catch (error) {
      bootstrapContextHasWarnings = true;
      console.warn("Cannot load customer/admin features during auth bootstrap", error);
    }
  }

  store.commit("getListFeature", listFeature);
  return currentUser;
}

const AuthBootstrapService = {};

AuthBootstrapService.reset = () => {
  bootstrapPromise = null;
  bootstrapContextHasWarnings = false;
  resetStoreAuthContext();
};

AuthBootstrapService.ensureBootstrapped = async (options = {}) => {
  if (!options.force && hasLoadedContext()) {
    return store.state.currentUser;
  }

  if (!options.force && bootstrapPromise) {
    return bootstrapPromise;
  }

  bootstrapPromise = AuthService.me()
    .then(async (response) => {
      store.commit("getCurrentUser", response.result);
      return loadUserAccessContext(response.result);
    })
    .catch((error) => {
      AuthBootstrapService.reset();
      throw error;
    })
    .finally(() => {
      bootstrapPromise = null;
    });

  return bootstrapPromise;
};

AuthBootstrapService.canAccessRoute = (to) => {
  if (!to.meta) {
    return true;
  }

  var listFeature = store.state.listFeature || [];
  var currentUser = store.state.currentUser;
  var userRoles = currentUser && currentUser.roles ? currentUser.roles : [];
  var currentEmployeeRoleCode = store.state.currentEmployeeRoleCode;
  var activeRoleCodes = currentEmployeeRoleCode
    ? [currentEmployeeRoleCode]
    : (store.state.listEmployeeRoles || []);

  var roleRestrictedCollections = {
    DashboardCEO: ["CEO"],
    DashboardHR: ["HR"],
    DashboardBusiness: ["KD"],
    Business: ["KD"],
    DocumentDrafting: ["CEO", "HR", "KD"],
  };

  if (
    currentEmployeeRoleCode &&
    to.meta.collection &&
    roleRestrictedCollections[to.meta.collection] &&
    !roleRestrictedCollections[to.meta.collection].includes(currentEmployeeRoleCode)
  ) {
    return false;
  }

  if (to.meta.allowAccess && to.meta.allowAccess.length > 0) {
    var hasRoleAccess = to.meta.allowAccess.some(function (allowAccess) {
      return (
        allowAccess === "*" ||
        activeRoleCodes.includes(allowAccess) ||
        userRoles.includes(allowAccess) ||
        listFeature.includes(allowAccess)
      );
    });
    if (!hasRoleAccess) {
      return false;
    }
  }

  if (!to.meta.code || to.meta.code.includes("*")) {
    return true;
  }

  return listFeature.some((featureCode) => to.meta.code.indexOf(featureCode) !== -1);
};

AuthBootstrapService.hasBootstrapContextWarnings = () => bootstrapContextHasWarnings;

AuthBootstrapService.isAuthFailure = (error) => {
  const response = error && error.response ? error.response : null;
  const responseData = response && response.data ? response.data : null;
  const meta = error && error.meta ? error.meta : null;
  const status =
    (error && error.status) ||
    (error && error.code) ||
    (response && response.status) ||
    (meta && meta.status);
  const detail = String(
    (error && error.detail) ||
    (error && error.message) ||
    (error && error.error) ||
    (responseData && responseData.detail) ||
    ""
  ).toLowerCase();

  return (
    status === 401 ||
    status === 403 ||
    detail.includes("denied") ||
    detail.includes("unauthorized") ||
    detail.includes("forbidden") ||
    detail.includes("token") ||
    detail.includes("login")
  );
};

export default AuthBootstrapService;
